<template>
  <div>
		<el-form class="wy-form" :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="isEn ? '215px' : '120px'">
		  <el-form-item :label="$t('message.srjmm')" prop="oldPassword">
				<el-input type="password" class="wy-input" v-model="ruleForm.oldPassword" :placeholder="$t('message.srjmm')"></el-input>
			</el-form-item>
			<el-form-item :label="$t('message.srxmm')" prop="newPassword">
				<el-input type="password" class="wy-input" v-model="ruleForm.newPassword" :placeholder="$t('message.srxmm')"></el-input>
			</el-form-item>
			<el-form-item :label="$t('message.qrxmm')" prop="repeatPass">
				<el-input type="password" class="wy-input" v-model="ruleForm.repeatPass" :placeholder="$t('message.qrxmm')"></el-input>
			</el-form-item>
			<div class="wy-btn-boder">
				<div class="wy-cancel" @click="close">{{ $t('message.cancel') }}</div>
				<div class="wy-sure" :class="{'isSubmiting': isSubmiting}" @click="sure">{{ isSubmiting ? $t('message.isSubmiting') : $t('message.qd') }}</div>
			</div>
		</el-form>
	</div>
</template>

<script>
import request from '@/axios/request.js';
import myMixin from '@/mixins/myMixin.js';

export default {
	mixins: [myMixin],
	data () {
		var checkRepeatPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('message.qrxmm')));
      } else if (this.ruleForm.newPassword != value) {
        return callback(new Error(this.$t('message.mmbyz')));
      } else {
        callback();
      }
    }
		return {
			isSubmiting: false,
			ruleForm: {
				oldPassword: '',
				newPassword: '',
				repeatPass: '',
			},
			rules: {
				oldPassword: [
					{ required: true, message: this.$t('message.srjmm'), trigger: 'change' }
				],
				newPassword: [
					{ required: true, message: this.$t('message.srxmm'), trigger: 'change' }
				],
				repeatPass: [
					{ required: true, message: this.$t('message.qrxmm'), trigger: 'change' },
					{ validator: checkRepeatPass, trigger: 'change' }
				]
			}
		}
	},
	methods: {
		async submitVoid () {
			let userId = window.sessionStorage.getItem('userId');
			let userName = window.sessionStorage.getItem('userName');
			let params = {
				userId: userId,
				userName: userName,
				oldPassword: this.ruleForm.oldPassword,
				newPassword: this.ruleForm.newPassword
			};
			try {
				let res = await request.post('/user/updatePwd', params);
				if (res.code == 200) {
					this.isSubmiting = false;
					this.$store.commit('CHANGE_ALERT_TEXT', this.$t('message.xgmmcg'));
					this.$store.commit('CHANGE_ALERT_SHOW', true);
				} else if (res.code == 401) {
					this.$message({
						message: res.msg || '错误',
						type: 'warning'
					});
					this.isSubmiting = false;
					this.logot();
				}
			} catch (error) {
				this.$message({
					message: error,
					type: 'warning'
				});
				this.isSubmiting = false;
			}
		},
		sure () {
			if (this.isSubmiting) {
        return;
      }
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
          this.isSubmiting = true;
					this.submitVoid();
        } else {
          console.log('error submit!!');
          return false;
        }
			});
		},
		close () {
			this.$store.commit('CHANGE_PASS_SHOW', false);
		}
	},
	computed: {
		isEn() {
			return this.$i18n.locale == 'en';
		}
	}
}
</script>

<style scoped>
.wy-form {
	padding-right: 15px;
}
</style>